export const ACTIONS_BERU = {
  INIT_ORDERS: 'INIT_ORDERS',
  DELETE_ORDERS: 'DELETE_ORDERS',
};

export const initBeruOrders = data => ({
  type: ACTIONS_BERU.INIT_ORDERS,
  data,
});

export const deleteBeruOrders = () => ({
  type: ACTIONS_BERU.DELETE_ORDERS,
});
